export default "__VITE_ASSET__DZEEhzfa__"